import { type MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import Box from '@/components/ui/Box/Box';
import Grid from '@/components/ui/Grid/Grid';
import IconButton from '@/components/ui/IconButton/IconButton';
import LoadingButton from '@/components/ui/LoadingButton/LoadingButton';
import Typography from '@/components/ui/Typography/Typography';
import type { ResetEmailLocationState } from './IPasswordResetEmailSentPage';
import { styles } from './styles';

const PasswordResetEmailSentPage = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const email = (state as ResetEmailLocationState | null)?.email ?? '';

    const handlePreventDefault = (e: MouseEvent<HTMLButtonElement>) => e.preventDefault();

    return (
        <Grid container item alignItems="center" justifyContent="center" gap="44px">
            <Grid container item direction="column" alignItems="center" justifyContent="center">
                <Grid container item alignItems="center" justifyContent="space-between">
                    <Grid item xs={1}>
                        <IconButton
                            aria-label="back"
                            onClick={() => navigate(-1)}
                            onMouseDown={handlePreventDefault}
                            onMouseUp={handlePreventDefault}
                            edge="end"
                        >
                            <ArrowBack style={styles.backButton} fontSize="small" />
                        </IconButton>
                    </Grid>
                    <Grid item xs>
                        <Typography align="center" variant="h3" sx={styles.logoText}>
                            Check your inbox
                        </Typography>
                    </Grid>
                    <Grid item xs={1} />
                </Grid>
                <span role="img" aria-label="incoming envelope" style={styles.incomingEnvelopeImg}>
                    {String.fromCodePoint(0x1f4e8)}
                </span>
            </Grid>
            <Box sx={styles.formStack}>
                <Typography align="center" variant="body1">
                    An email has been sent to &apos;{email}&apos;.
                </Typography>
                <Typography align="center" variant="body1">
                    If this is a registered account, you can follow the instructions to reset your password.
                </Typography>
                <LoadingButton
                    type="button"
                    color="secondary"
                    variant="contained"
                    fullWidth
                    onClick={() => navigate('/login')}
                >
                    BACK TO SIGN IN
                </LoadingButton>
            </Box>
        </Grid>
    );
};

export default PasswordResetEmailSentPage;
